import View from './View';
import svg from 'url:../../img/icons.svg';

class BookmarksView extends View {
  _parentElement = document.querySelector('.bookmarks__list');
  _errorMsg = ` No bookmarks yet. Find a nice recipe and bookmark it :)`;
  _Msg = `Start by searching for a recipe or an ingredient. Have fun!`;

  _generateMarkup() {
    let id = window.location.hash.slice(1);
    return this._data
      .map(el => {
        /*
          <li class="preview">
                    <a class="preview__link" href="#23456">
                      <figure class="preview__fig">
                        <img src="src/img/test-1.jpg" alt="Test" />
                      </figure>
                      <div class="preview__data">
                        <h4 class="preview__name">
                          Pasta with Tomato Cream ...
                        </h4>
                        <p class="preview__publisher">The Pioneer Woman</p>
                      </div>
                    </a>
                  </li>
          */
        return `
    <li class="preview">
    <a class="preview__link ${
      el.id === id ? 'preview__link--active' : ''
    }" href="#${el.id}">
      <figure class="preview__fig">
        <img src="${el.imageUrl}" alt="${el.title}" />
      </figure>
      <div class="preview__data">
        <h4 class="preview__title">${el.title}...</h4>
        <p class="preview__publisher">${el.publisher}</p>
    
        <div class="preview__user-generated ${el.key ? '' : 'hidden'}">
                <svg>
                  <use href="${svg}#icon-user"></use>
                </svg>
          </div>
      </div>
    </a>
  </li>
      `;
      })
      .join('');
  }
  addHandlerRender(handler) {
    window.addEventListener('load', handler);
  }
}
export default new BookmarksView();
